class CartWatcher {

    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
       
      });
    }
  
    async fetchCart() {
      const response = await fetch('/cart.js');

      return response.json();
    }
  
    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  
   storedCart() {
      
      
        
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }
  
   findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
  
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item)
      });
  
      return result;
    }
  
    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
  
      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);
  
      this.storeCart(newCart);

    }
  
   observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
}
    const myCartWatcher = new CartWatcher();
    myCartWatcher.init();

    window.addEventListener("cart_changed", (cart) => {
        console.log("Added items:", cart.detail.added);

        if (cart.detail.added.length === 0) return;

        const event = new CustomEvent("openCartDrawer", {
            detail: {}
        });
        document.body.dispatchEvent(event);
       
    });
    (function () {
    const SELECTOR = '#product-grid form[action^="/cart/add"] button[type="submit"]';
    const addingHtml = `<span>Adding...</span>
        <div class="loading-overlay__spinner">
        <span class="spinner">
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-button-load">
            <path d="M17.5 9a8 8 0 11-8-8" stroke="#fff" stroke-width="2" stroke-linecap="round"></path>
            </svg>
        </span>
        </div>`;
    const addedHtml = `<span class="special-added-to-cart">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.3333 5.68002L7.625 14.3884L3.66666 10.43" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>Added</span>`;

    function setAdding(btn) {
        if (!btn) return;
        btn.disabled = true; 
        btn.classList.add('loading-state-add');
        btn.innerHTML = addingHtml;

        setTimeout(() => {
        btn.classList.remove('loading-state-add');
        btn.innerHTML = addedHtml;
        btn.disabled = false; 
        }, 3500);
    }

    function resetAllButtons() {
        document.querySelectorAll(SELECTOR).forEach(btn => {
        btn.classList.remove('loading-state-add');
        btn.disabled = false;
        btn.innerHTML = '<span>Add to cart</span>';
        });
    }

    document.addEventListener('click', (e) => {
        const btn = e.target.closest(SELECTOR);
        if (btn) {
        setAdding(btn);
        }
    }, true);

    document.addEventListener('cartDrawer:close', resetAllButtons);

    })();
   